import { uniqueBy } from 'utils/core/array';

import type { ProductNode } from './model';

/**
 * Collects the ids of every descendant of `node` (children, grandchildren, …), excluding `node`'s own id.
 *
 * Field-count badges must include fields that are nested inside intermediate group nodes — e.g. the
 * AdvancedParameters tab whose fields live under the SpecificPricing / Deka sub-groups — not just the
 * tab's direct children. Container ids are harmless in the count: they never appear in the patched /
 * invalid field lists.
 */
export function collectDescendantNodeIds(node: ProductNode | undefined): string[] {
  if (!node?.children) {
    return [];
  }
  return uniqueBy(
    node.children.flatMap(child => [child.id, ...collectDescendantNodeIds(child)]),
    id => id,
  );
}

/** Same as {@link collectDescendantNodeIds} but for a list of sibling nodes, including their own ids. */
export function collectNodesAndDescendantIds(nodes: ReadonlyArray<ProductNode> | undefined): string[] {
  if (!nodes) {
    return [];
  }
  return nodes.flatMap(node => [node.id, ...collectDescendantNodeIds(node)]);
}
